import type { FC } from "react";

import { Spacer, Skeleton, Columns, Column } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import * as styles from "./SignInForm.styles";

const SkeletonSignInForm: FC = () => {
  const { tablet } = useBreakpoints();
  return (
    <>
      <Skeleton type="button" isFullwidth css={styles.marginBottom} />
      <Skeleton type="button" isFullwidth css={styles.marginBottom} />
      <div css={styles.row}>
        <Skeleton type="typography" typographySize="body" margin="topAndBottom" />
      </div>
      <Spacer height="one" />
      <Columns css={styles.row}>
        {tablet.greaterThan && (
          <Column isPaddingless preserveMobileColumns columnWidth={6} css={styles.flex}>
            <Skeleton type="button" width={1} height={1} />
            <Spacer width="half" />
            <Skeleton type="typography" typographySize="body" />
          </Column>
        )}
        <Skeleton type="button" isFullwidth />
      </Columns>
    </>
  );
};

export { SkeletonSignInForm };
